module.exports = __webpack_public_path__ + "img/title_head-1.a5a3e9f4.jpg";